import { Aside, CardLoader, Page } from "shared/react";
import { type CreatorEntity, getMemberAllowedPrivacyTypes } from "shared/schema";
import { EntityCard } from "../entity/EntityCard.js";
import { EntityHeader } from "../entity/EntityHeader.js";
import { useMemberData } from "../util/data.js";
import { useQuery } from "../util/db.js";
import { useGroupContext } from "./GroupContext.js";

export function AssignedChallengesPage(): React.ReactElement {
	const { id: gid } = useGroupContext();
	const member = useMemberData(gid);
	const privacy = getMemberAllowedPrivacyTypes(member);
	const creator: CreatorEntity = `group:${gid}`;
	const items = useQuery("list", { creator, privacy, slug: "assigned" }).optionalFirst?.items || [];
	return (
		<Page title="Assigned challenges" path="./assigned">
			<EntityHeader entity={creator}>
				<h1>Assigned challenges</h1>
			</EntityHeader>
			{items.length ? (
				<section>
					{items.map(item => (
						<CardLoader key={item}>
							<EntityCard entity={item} />
						</CardLoader>
					))}
				</section>
			) : (
				<Aside>No challenges assigned</Aside>
			)}
		</Page>
	);
}
